import type { ColumnDef, HistogramMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn } from '../shared/pivot.js';

export interface HistogramResult {
  values: number[];
  labels?: string[];
}

export function prepHistogramSeries(
  rows: Record<string, unknown>[],
  _columnDefs: ColumnDef[],
  mapping: HistogramMapping
): HistogramResult {
  const tableData = rowsToColumnar(rows);
  const values = getColumn<number>(tableData, mapping.values).map((v) => Number(v) || 0);
  if (mapping.labels) {
    return { labels: getColumn<string>(tableData, mapping.labels).map(String), values };
  }
  return { values };
}
